import { isMobile } from "@utils/userSegment";

export function shouldAskForPhoneNumber() {
  return !isMobile();
}
